import { Flex } from 'dash-ui';
import styled from 'styled-components';

export const FlexWraper = styled(Flex)`
  flex-direction: row;
  @media ${({ theme }) => theme.devices.mobile} {
    flex-direction: column;
    gap: 20px;
  }
`;

export const SubFlexWraper = styled(Flex)`
  margin-left: 12px;
  @media ${({ theme }) => theme.devices.mobile} {
    margin: 0;
  }
`;
